module.exports = __webpack_public_path__ + "img/icon-package-topup-option-light.21c2e4f.svg";